import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import formatISODate from '../../../Helpers/formatISODate'
import './styles.scss'

const STEPS = ['Picked Up', 'In Transit', 'Arrived', 'Delivered']

const statusToStep = (status) => {
  switch (status) {
    case 'Picked Up': return 0
    case 'Active':    return 1
    case 'Arrived':   return 2
    case 'Delivered': return 3
    default:          return -1
  }
}

const formatDate = (d) => {
  const raw = formatISODate(d)
  if (!raw) return '—'
  const [date] = raw.split(' ')
  return date
}


const TrackItResult = ({ trackItResult }) => {
  const activeStep = statusToStep(trackItResult.status)
  const isOnHold   = trackItResult.status === 'On hold'
  const isInactive = trackItResult.status === 'Inactive'

  return (
    <div className="track-it-result">

      {/* Summary card */}
      <div className="track-it-result__summary">
        <div className="track-it-result__summary__left">
          <p className="track-it-result__summary__label">Tracking Number</p>
          <h2 className="track-it-result__summary__number">
            {trackItResult.trackingNumber}
          </h2>
          <span className={`status-badge status-badge--${isOnHold ? 'hold' : isInactive ? 'inactive' : activeStep === 3 ? 'delivered' : 'active'}`}>
            {isOnHold && <FontAwesomeIcon icon={solid('circle-pause')} />}
            {activeStep === 3 && <FontAwesomeIcon icon={solid('circle-check')} />}
            {!isOnHold && activeStep !== 3 && <FontAwesomeIcon icon={solid('circle-dot')} />}
            {trackItResult.status}
          </span>
        </div>

        <div className="track-it-result__summary__meta">
          <div className="meta-item">
            <span className="meta-item__label">Dispatched</span>
            <span className="meta-item__value">{formatDate(trackItResult.dispatchDate)}</span>
          </div>
          <div className="meta-arrow">
            <FontAwesomeIcon icon={solid('arrow-right')} />
          </div>
          <div className="meta-item">
            <span className="meta-item__label">Est. Delivery</span>
            <span className="meta-item__value">{formatDate(trackItResult.estimatedDeliveryDate)}</span>
          </div>
          {trackItResult.currentLocation && (
            <div className="meta-item meta-item--location">
              <span className="meta-item__label">Current Location</span>
              <span className="meta-item__value">
                <FontAwesomeIcon icon={solid('location-dot')} />
                {' '}{trackItResult.currentLocation}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Progress stepper */}
      <div className={`track-it-result__stepper${isOnHold ? ' track-it-result__stepper--hold' : ''}`}>
        {STEPS.map((step, i) => {
          const done    = !isOnHold && activeStep > i
          const current = !isOnHold && activeStep === i
          return (
            <div key={step} className="stepper-step">
              <div className={`stepper-step__circle${done || current ? ' stepper-step__circle--active' : ''}${done ? ' stepper-step__circle--done' : ''}`}>
                {done
                  ? <FontAwesomeIcon icon={solid('check')} />
                  : <span>{i + 1}</span>
                }
              </div>
              <span className={`stepper-step__label${done || current ? ' stepper-step__label--active' : ''}`}>
                {step}
              </span>
              {i < STEPS.length - 1 && (
                <div className={`stepper-step__line${done ? ' stepper-step__line--done' : ''}`} />
              )}
            </div>
          )
        })}
        {isOnHold && (
          <div className="stepper-hold-notice">
            <FontAwesomeIcon icon={solid('triangle-exclamation')} />
            Shipment is currently on hold. Contact support for details.
          </div>
        )}
      </div>

      {/* Shipment summary strip */}
      <div className="track-it-result__strip">
        <div className="strip-col">
          <span className="strip-col__icon"><FontAwesomeIcon icon={solid('user')} /></span>
          <span className="strip-col__label">From</span>
          <span className="strip-col__value">{trackItResult.senderName || '—'}</span>
        </div>

        <div className="strip-divider">
          <FontAwesomeIcon icon={solid('arrow-right')} />
        </div>

        <div className="strip-col strip-col--center">
          <span className="strip-col__icon"><FontAwesomeIcon icon={solid('box')} /></span>
          <span className="strip-col__label">Package</span>
          <span className="strip-col__value">{trackItResult.packageDescription || '—'}</span>
        </div>

        <div className="strip-divider">
          <FontAwesomeIcon icon={solid('arrow-right')} />
        </div>

        <div className="strip-col strip-col--right">
          <span className="strip-col__icon"><FontAwesomeIcon icon={solid('user-check')} /></span>
          <span className="strip-col__label">To</span>
          <span className="strip-col__value">{trackItResult.receiverName || '—'}</span>
        </div>
      </div>

    </div>
  )
}

export default TrackItResult
